import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchParameters, updateParameters} from "../../../redux_slices/parametersSlice";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {useTranslation} from "react-i18next";
import {getContextSilent, loadParameter} from "../../../redux_slices/contextSlice";
import {updateImgsSettings} from "../../../redux/Settings/settingsCrud";
import {TextInput, UploadInput} from "../../../widgets";

const LoginSettings = props => {
    const {t} = useTranslation();

    const parametersStatus = useSelector(state => state.parameters.status);
    const dispatch = useDispatch();

    const loginLogo = useSelector(state => loadParameter(state, "loginLogo"));
    const loginBackground = useSelector(state => loadParameter(state, "loginBackground"));
    const loginTitle = useSelector(state => loadParameter(state, "loginTitle"));
    const loginDescription = useSelector(state => loadParameter(state, "loginDescription"));
    const loginExtraLink = useSelector(state => loadParameter(state, "loginExtraLink"));
    const loginExtraLinkText = useSelector(state => loadParameter(state, "loginExtraLinkText"));

    useEffect(() => {
        dispatch(fetchParameters());
    }, []);

    //local state:

    const onImageUpload = async ({file, picType, onConfirmUploaded, onError}) => {
        try {
            if (file) {
                const onSuccess = () => {
                    dispatch(getContextSilent());
                    onConfirmUploaded();
                };
                await updateImgsSettings({
                    picType,
                    file,
                    onSuccess,
                    onError,
                });
                await dispatch(getContextSilent());
            }
        } catch (err) {
            console.error("Failed to save the credential: ", err);
        }
    };

    const onSettingChange = async values => {
        try {
            await dispatch(updateParameters({values: values}));
            await dispatch(getContextSilent());
        } catch (err) {
            console.error("Failed to save the credential: ", err);
        }
    };

    let disabled = parametersStatus.type === "loading";
    let content;
    if (parametersStatus.type === "succeeded") {
        content = (
            <div className="form">
                <UploadInput
                    langTitle={t("ADMINPANEL.COMPANY_LOGO.TITLE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.LOGO.SUBTITLE")}
                    langPlaceholder={t("ADMINPANEL.COMPANY_LOGO.TOOLTIP.EDIT_LOGO")}
                    value={loginLogo}
                    parameterType="loginLogo"
                    onImageUpload={onImageUpload}
                    disabled={disabled}
                    fileType={"images/*"}
                />
                <UploadInput
                    langTitle={t("ADMINPANEL.LOGINPAGE.LATERAL_PIC.TITLE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.LATERAL_PIC.SUBTITLE")}
                    langPlaceholder={t("ADMINPANEL.GENERAL.TOOLTIP.EDIT_HEADER")}
                    value={loginBackground}
                    parameterType="loginBackground"
                    onImageUpload={onImageUpload}
                    disabled={disabled}
                    fileType={"image/*"}
                    previewClassName="preview_loginBg"
                />
                <TextInput
                    langTitle={t("ADMINPANEL.LOGINPAGE.LOGIN_TITLE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.LOGIN_TITLE.DETAIL")}
                    langPlaceholder={t("ADMINPANEL.LOGINPAGE.LOGIN_TITLE.PLACEHOLDER")}
                    defaultValue={loginTitle}
                    parameterType="loginTitle"
                    onSettingChange={onSettingChange}
                    disabled={disabled}
                />
                <TextInput
                    langTitle={t("ADMINPANEL.LOGINPAGE.LOGIN_MESSAGE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.LOGIN_MESSAGE.DETAIL")}
                    langPlaceholder={t("ADMINPANEL.LOGINPAGE.LOGIN_MESSAGE.PLACEHOLDER")}
                    defaultValue={loginDescription}
                    parameterType="loginDescription"
                    onSettingChange={onSettingChange}
                    disabled={disabled}
                />
                <TextInput
                    langTitle={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.TITLE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.SUBTITLE")}
                    langPlaceholder={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.TEXT.PLACEHOLDER")}
                    defaultValue={loginExtraLink}
                    parameterType="loginExtraLink"
                    onSettingChange={onSettingChange}
                    disabled={disabled}
                />
                <TextInput
                    langTitle={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.TEXT.TITLE")}
                    langSubTitle={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.TEXT.SUBTITLE")}
                    langPlaceholder={t("ADMINPANEL.LOGINPAGE.EXTRA_LINK.TEXT.PLACEHOLDER")}
                    defaultValue={loginExtraLinkText}
                    parameterType="loginExtraLinkText"
                    onSettingChange={onSettingChange}
                    disabled={disabled}
                />
            </div>
        );
    } else if (parametersStatus.type === "loading") {
        content = (
            <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100 z-index-2">
                <CircularProgress />
            </div>
        );
    } else if (parametersStatus.type === "failed") {
        content = (
            <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100 z-index-2">
                <div
                    className={`alert alert-${parametersStatus.type ||
                        "warning"} font-weight-bold w-fit-content d-flex align-items-center`}
                >
                    <WarningRoundedIcon color="inherit" className="mr-5" /> {t(parametersStatus.error)}{" "}
                </div>
            </div>
        );
    }
    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                    <div className="card-title">{t("ADMINPANEL.LOGINPAGE.TITLE")}</div>
                </div>
                <div className="card-body position-relative min-h-180px">
                    <div className="d-flex flex-column justify-content-center z-index-1">{content}</div>
                </div>
            </div>
        </div>
    );
};

export default LoginSettings;
